import React from 'react'
import ResourceLinkNav from '../components/shared/ResourceLinkNav/ResourceLinkNav'
import TrainingStepByStep from '../components/AthleteSafetyRVP/TrainingStepByStep/TrainingStepByStep';
import AdminView from '../components/shared/AdminView';

function TrainingStepByStepPage() {
  return (
    <ResourceLinkNav>
      <AdminView />
      <TrainingStepByStep />
    </ResourceLinkNav>
  );
}

export default TrainingStepByStepPage;